import { createAction } from '@reduxjs/toolkit';

export const setCurrentStep = createAction('StepSmartEmailAddress/currentStep/set');
export const clearEmailAddress = createAction('StepSmartEmailAddress/emailaddress/clear');
export const setEmailAddress = createAction('StepSmartEmailAddress/emailaddress/set');
